<template>
	<section class="app-plan">
		<div class="app-plan__top">
			<template v-if="recommended">
				<h2 class="app-plan__title">
					<template v-if="current_company === 'megafon'">
						{{ $t('recommended_megafon_plan') }}
					</template>
					<template v-else>
						{{ $t('recommended_programms') }}
					</template>
				</h2>
			</template>
			<template v-else>
				<h2 class="app-plan__title">
					<template v-if="current_company === 'megafon'">
						<template v-if="!filteredSelection(selection).length">
							{{ $t('megafon_plan') }}
						</template>
						<template v-else>
							{{ $t('megafon_plan_completed_to') }}
							<span class="sub-light-font-color">{{ learning_plan_result }}%</span>
						</template>
					</template>
					<template v-else-if="is_condidate">
						<template v-if="!filteredSelection(selection).length">
							{{ $t('condidate_learning_plan') }}
						</template>
						<template v-else>
							{{ $t('condidate_learning_plan_completed_to') }}
							<span class="sub-light-font-color">{{ learning_plan_result }}%</span>
						</template>
					</template>
					<template v-else>
						{{ $t('learning_plan') }}
					</template>
				</h2>
			</template>
			<p v-if="(filteredSelection(selection).length && (!is_condidate || current_company === 'megafon'))" class="app-plan__progress">
				{{ $t('completed_on') }} {{ learning_plan_result }}%
			</p>
		</div>

		<div class="app-plan__results">
			<ul v-if="filteredSelection(selection).length" class="app-plan__list catalog__list--plan">
				<li
					v-for="(prescription, index) in filteredSelection(selection)"
					:key="'section-' + prescription.id + '-' + index"
				>
					<PlanPreview
						:prescription="prescription"
						:currentCompany="current_company"
						:recommended="recommended"
					/>
				</li>
			</ul>
			<template v-else>
				<template v-if="recommended">
					<div v-if="current_company === 'megafon'" class="app-plan__message-holder">
						<p class="app-plan__message-top">{{ $t('messages.recommended_megafon_1') }}</p>
						<p class="app-plan__message-bottom">{{ $t('messages.recommended_megafon_2') }}</p>
					</div>
					<div v-else class="app-plan__message-holder">
						<p class="app-plan__message-top">{{ $t('messages.no_recommended_training') }}</p>
						<p class="app-plan__message-bottom">{{ $t('messages.choose_description') }}</p>
					</div>
				</template>
				<template v-else>
					<div v-if="current_company === 'megafon'" class="app-plan__message-holder">
						<p class="app-plan__message-top">{{ $t('messages.megafon_1') }}</p>
						<p class="app-plan__message-bottom">{{ $t('messages.megafon_2') }}</p>
					</div>
					<div v-else class="app-plan__message-holder">
						<p class="app-plan__message-top">{{ $t('messages.no_training') }}</p>
						<p class="app-plan__message-bottom">{{ $t('messages.choose_description') }}</p>
					</div>
				</template>
			</template>
		</div>
		<div class="app-plan__bottom">
			<a v-if="filteredSelection(selection).length" :href="recommended ? '/recommended_prescriptions': '/prescriptions'" class="app-btn app-btn--outline app-btn--round">
				{{ $t('buttons.show_more') }}
			</a>
			<a v-else-if="current_company !== 'megafon'" href="/courses" class="app-btn app-btn--outline app-btn--round">
				{{ $t('buttons.choose_course') }}
			</a>
		</div>
	</section>
</template>

<script>
import PlanPreview from "./PlanPreview.vue";

export default {
	name: "PlanSelection",

	components: {
		PlanPreview
	},

	props: {
		selection: Array,
		learning_plan_result: String,
		newCourses: {
			type: Boolean,
			default: false,
		},
		current_company: {
			type: String,
			default: ''
		},
		recommended: {
			type: Boolean,
			default: false
		},
		is_condidate: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			uncompletedOnly: false,
			loading: true,
			isContinue: false,
			currentLocale: window.currentLocale
		};
	},

	methods: {
		filteredSelection(selection) {
			return this.uncompletedOnly
				? selection.filter((prescription) => prescription.result != 100)
				: selection;
		}
	}
};
</script>
